/**
 * 自然流量 FTU 弹窗频次试验（experiment_id: 751）
 * routed_group_variation：1 = 实验组，2 = 对照组（与 api/data.ts 约定一致）
 * 试验结束后删除本文件，并移除 utils/ftu.ts 中的 import 与 isTreatment 分支即可。
 */

import { getABExperimentResult } from '@/api/data';

export const FTU_ORGANIC_FREQUENCY_EXPERIMENT_ID = 751;

type AbExperimentObject = {
  has_joined_experiment?: boolean;
  routed_group_variation?: string;
};

/** 实验组 true（variation=1 且已入组）；对照组 variation=2、未入组、接口失败均为 false */
export function isFtuOrganicTreatmentGroup(
  abRes: { result?: boolean; object?: AbExperimentObject } | null | undefined
): boolean {
  const obj = abRes?.object;
  if (abRes?.result !== true || !obj || obj.has_joined_experiment === false) {
    return false;
  }
  return String(obj.routed_group_variation) === '1';
}

/** 自然流量且即将算频次时调用；ctx 供 SSR */
export function fetchFtuOrganicFrequencyExperiment(ctx?: any) {
  return getABExperimentResult({ experiment_id: FTU_ORGANIC_FREQUENCY_EXPERIMENT_ID }, { ctx }).catch(() => null);
}
